import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typeof',
  standalone: false
})
export class TypeofPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    return typeof value;
  }
}
